module.exports = __webpack_public_path__ + "static/media/academy.8e1e2779.png";